(function () {
	'use strict';
	$(document).ready(function () {

		//Form logic
		function sendContactForm(formId) {

			var contactName = $('input[name=cf-name]').val();
			var contactSubject = $('input[name=cf-subject]').val();
			var contactMessage = $('textarea[name=cf-message]').val();

			var contactConsents = [];
			$(formId + ' .ContactConsent').each(function () {
				var consentText = $(this).siblings('label').find('.text').text();
				var consentAnswer = $(this).is(':checked') ? 'TAK' : 'NIE';
				var consentAnswers = {
					"consentText": consentText,
					"consentAnswer": consentAnswer,
				}
				contactConsents.push(consentAnswers);
			});

			var json_arr = JSON.stringify(contactConsents);

			var data = new FormData();

			data.append('contactName', contactName);
			data.append('contactSubject', contactSubject);
			data.append('contactMessage', contactMessage);
			data.append('contactConsents', json_arr);
			data.append('action', 'send_contact_form');


			grecaptcha.ready(function () {
				grecaptcha.execute('6LdZXSAhAAAAAHQUXjMjS3fqbjjhTF-80ikAAJKD', { action: 'submit' }).then(function (token) {
					data.append('recaptcha_token', token);
					$.ajax({
						url: "/wp-admin/admin-ajax.php",
						processData: false,
						contentType: false,
						type: "POST",
						timeout: 10000,
						data: data,
						success: function (data) {
							if (data == '1') {
								$(formId + ' .ajax-success').slideDown();
								$(formId).trigger("reset");
							} else {
								$(formId + ' .ajax-error').slideDown();
							}
						},
						error: function (data) {
							$(formId + ' .ajax-error').slideDown();
						},
						beforeSend: function () {
							$(formId + ' .ajax-success').slideUp();
							$(formId + ' .ajax-loading').slideDown();
							$(formId + ' .ajax-error').slideUp();
						},
						complete: function () {
							$(formId + ' .ajax-loading').slideUp();
						},
					});
				})
			});

		}

		$('#cf-submit').on('click', function (e) {
			e.preventDefault();
			var contactFormId = '#' + $(this).closest('form').attr('id');
			$(contactFormId + ' *').removeClass('HasError');

			var isAllValid = true;

			var fieldsToValidationText = ['#cf-name', '#cf-subject', '#cf-message'];
			$(fieldsToValidationText).each(function(index, element) {
				if (!$(element).val()) {
					$(this).addClass('HasError');
					isAllValid = false;
				}
			});

			$(contactFormId + ' .ContactConsentReq').each(function() {
				if (!$(this).is(':checked')) {
					$(this).addClass('HasError');
					isAllValid = false;
				}
			});

			if (!isAllValid) {
				return;
			}

			sendContactForm(contactFormId);
		});

	});
}(jQuery));